import React from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components/macro'
import { colorsToSwitch } from '../../utils/styles'
import { switchProp } from 'styled-tools'
import Button from '../Button'

export const allowedColors = [
  'base',
  'primary',
  'secondary',
  'error'
]

export const SIZE = 44

const rotate = keyframes`
  to { transform: rotate(360deg); }
`
const circularDash = keyframes`
  0% {
    stroke-dasharray: 1px 200px;
    stroke-dashoffset: 0px;
  }

  50% {
    stroke-dasharray: 100px 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px 200px;
    stroke-dashoffset: -120px;
  }
`

export const Circle = styled.circle.attrs(props => ({
  cx: SIZE,
  cy: SIZE,
  r: (SIZE - props.thickness) / 2,
  fill: 'none',
  strokeWidth: props.thickness
}))`
  stroke: currentColor;
  stroke-dasharray: 80px 200px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  will-change: stroke-dasharray, stroke-dashoffset;
  animation: ${circularDash} 1.4s ease-in-out infinite;
`

export const Svg = styled.svg.attrs(props => ({
  viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
  width: props.size,
  height: props.size
}))`
  display: inline-block;
  animation: ${rotate} 1.4s linear infinite;
  color: ${switchProp('color', colorsToSwitch(allowedColors))};
  will-change: transform;

  ${Button} & {
    vertical-align: middle;
    margin-left: .75em;
  }
`

export default function CircularProgress({ size, thickness, color, ...props }) {
  return (
    <Svg {...props} size={size} color={color} role='progressbar'>
      <Circle size={size} thickness={thickness} />
    </Svg>
  )
}

CircularProgress.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  thickness: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  color: PropTypes.oneOf(allowedColors)
}

CircularProgress.defaultProps = {
  size: 40,
  thickness: 3.6,
  color: 'base'
}
